import { forwardRef } from "react";
import { useFormContext } from "react-hook-form";
import type { FormInputProps } from "@circle-react-uikit/Form/FormInput";
import { FormInput } from "@circle-react-uikit/Form/FormInput";
import { prependProtocol } from "./prependProtocol";

interface LinkInputProps extends FormInputProps {
  allowMailTo?: boolean;
  name: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const LinkInput = forwardRef<HTMLInputElement, LinkInputProps>(
  ({ name, allowMailTo = false, onBlur, ...rest }, ref) => {
    const { setValue } = useFormContext();

    const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      const newValue = prependProtocol(e.target.value, { allowMailTo });
      setValue(name, newValue, { shouldValidate: true });
      onBlur?.(e);
    };

    return (
      <FormInput
        {...rest}
        ref={ref}
        type="url"
        name={name}
        onBlur={handleOnBlur}
      />
    );
  },
);

LinkInput.displayName = "LinkInput";
